import React from 'react';

import { Search } from 'lucide-react';

import type { SimpleIconInterface } from './icon-utils';

export function SearchIcon({
  className,
  dataCy,
  height = 24,
  stroke,
  strokeWidth,
  style,
  width = 24,
}: SimpleIconInterface) {
  return (
    <Search
      className={className}
      data-cy={dataCy}
      height={height}
      stroke={stroke ?? 'currentColor'}
      strokeWidth={strokeWidth}
      style={style}
      width={width}
    />
  );
}
